
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"13","viewBox":"0 0 1717 448"}},[_c('path',{attrs:{"fill":"#003f79","d":"M1452.136 2.188l-66.938 70.292 119.875 114.188H0v93.333h1485.531l-100.333 95.521 66.938 70.292 232.896-221.813L1452.136 2.188z"}})])
      }
    
      }
    